import { ChangeDetectionStrategy, Component, OnInit, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthJwtService } from '../../services/auth-jwt.service';
import { DynamicCssService } from '../../services/dynamic-css.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
  private jwtService = inject(AuthJwtService);
  private router = inject(Router);
  private dynamicCss = inject(DynamicCssService);

  async ngOnInit(): Promise<void> {
    document.body.style.opacity = '0';
    await this.dynamicCss.loadStylesheetLink('main.css', 'main-css');
    document.body.style.opacity = '1';
  }

  user = signal('');
  password = signal('');
  loading = signal(false);
  error = signal('');

  onSubmit(): void {
    if (!this.user() || !this.password()) return;

    this.loading.set(true);
    this.error.set('');

    this.jwtService.login(this.user(), this.password()).subscribe({
      next: () => this.router.navigate(['/planner']),
      error: () => {
        this.error.set('Usuario o contraseña incorrectos.');
        this.loading.set(false);
      }
    });
  }
}
